import { GROWTH_SETTINGS_NAV } from '@elva/ui';
import type { StTabId } from '@elva/ui';

export const SETTINGS_DEFAULT_SECTION: StTabId = 'practice-profile';

export const SETTINGS_SAVE_SECTIONS = new Set<StTabId>(
  GROWTH_SETTINGS_NAV.filter((item) => item.id !== 'connections').map((item) => item.id),
);

export const SETTINGS_SECTIONS = new Set<StTabId>(
  GROWTH_SETTINGS_NAV.map((item) => item.id),
);

export function isSettingsSaveSection(section: StTabId): boolean {
  return SETTINGS_SAVE_SECTIONS.has(section);
}

export function settingsPath(section: StTabId): string {
  return `/settings/${section}`;
}

export function parseSettingsSection(section: string | undefined): StTabId | null {
  if (!section) return null;
  return SETTINGS_SECTIONS.has(section as StTabId) ? (section as StTabId) : null;
}

export function settingsSectionLabel(section: StTabId): string {
  return GROWTH_SETTINGS_NAV.find((item) => item.id === section)?.label ?? 'Settings';
}
